import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import styles from "../../_css/UsersPerLanguageChart.module.css";
import { DataLoader } from "../common/ResponseLoader";

const COLORS_ENGLISH = ["#2595D2", "#F2F4F8"];
const COLORS_ARABIC = ["#F59E0B", "#F2F4F8"];

const renderEnglishLabel = (
  { cx, cy, midAngle, innerRadius, outerRadius, percent, index },
  data
) => {
  if (index !== 0) return null;
  const RADIAN = Math.PI / 180;
  const offset = 8;
  const lineLength = 18;
  const angle = -midAngle * RADIAN;
  const sx = cx + outerRadius * Math.cos(angle);
  const sy = cy + outerRadius * Math.sin(angle);
  const ex = cx + (outerRadius + offset + lineLength) * Math.cos(angle);
  const ey = cy + (outerRadius + offset + lineLength) * Math.sin(angle);
  const lx = cx + (outerRadius + offset + lineLength) * Math.cos(angle);
  const ly = cy + (outerRadius + offset + lineLength) * Math.sin(angle);
  return (
    <g>
      <line
        x1={sx}
        y1={sy}
        x2={ex}
        y2={ey}
        stroke="#E5E7EB"
        strokeWidth={2}
      />
      <text
        x={lx}
        y={ly}
        fill="#2595D2"
        textAnchor={lx > cx ? "start" : "end"}
        dominantBaseline="central"
        fontSize={18}
        fontWeight={700}
      >
        {data[0].value}%
      </text>
    </g>
  );
};

const renderArabicLabel = (
  { cx, cy, midAngle, innerRadius, outerRadius, percent, index },
  data
) => {
  if (index !== 0) return null;
  const RADIAN = Math.PI / 180;
  const offset = 8;
  const lineLength = 24;
  const angle = -midAngle * RADIAN;
  const sx = cx + outerRadius * Math.cos(angle);
  const sy = cy + outerRadius * Math.sin(angle);
  const ex = cx + (outerRadius + offset + lineLength) * Math.cos(angle);
  const ey = cy + (outerRadius + offset + lineLength) * Math.sin(angle);
  const lx = cx + (outerRadius + offset + lineLength + 4) * Math.cos(angle);
  const ly = cy + (outerRadius + offset + lineLength + 4) * Math.sin(angle);
  return (
    <g>
      <line x1={sx} y1={sy} x2={ex} y2={ey} stroke="#E5E7EB" strokeWidth={2} />
      <text
        x={lx}
        y={ly}
        fill="#F59E0B"
        textAnchor={lx > cx ? "start" : "end"}
        dominantBaseline="central"
        fontSize={18}
        fontWeight={700}
      >
        {data[1].value}%
      </text>
    </g>
  );
};

const UsersPerLanguageChart = ({ data }) => (
  <div className={styles.card}>
    <h3 className={styles.title}>Users per Language</h3>
    {
      data.length > 0 ? <>
        <ResponsiveContainer width="100%" height={240}>
          <PieChart>
            {/* English colored arc with rounded ends */}
            <Pie
              data={[{ name: "English", value: data[0].value }]}
              cx="50%"
              cy="50%"
              innerRadius={75}
              outerRadius={90}
              startAngle={90}
              endAngle={90 - (360 * data[0].value) / 100}
              dataKey="value"
              label={(props) => renderEnglishLabel(props, data)}
              cornerRadius={16}
              isAnimationActive={false}
            >
              <Cell fill={COLORS_ENGLISH[0]} stroke="none" />
            </Pie>
            {/* English empty arc, flat ends */}
            <Pie
              data={[{ name: "Empty", value: 100 - data[0].value }]}
              cx="50%"
              cy="50%"
              innerRadius={75}
              outerRadius={90}
              startAngle={90 - (360 * data[0].value) / 100}
              endAngle={-270}
              dataKey="value"
              isAnimationActive={false}
            >
              <Cell fill={COLORS_ENGLISH[1]} stroke="none" />
            </Pie>
            {/* Arabic colored arc with rounded ends */}
            <Pie
              data={[{ name: "Arabic", value: data[1].value }]}
              cx="50%"
              cy="50%"
              innerRadius={50}
              outerRadius={65}
              startAngle={90}
              endAngle={90 - (360 * data[1].value) / 100}
              dataKey="value"
              label={(props) => renderArabicLabel(props, data)}
              cornerRadius={16}
              isAnimationActive={false}
            >
              <Cell fill={COLORS_ARABIC[0]} stroke="none" />
            </Pie>
            {/* Arabic empty arc, flat ends */}
            <Pie
              data={[{ name: "Empty", value: 100 - data[1].value }]}
              cx="50%"
              cy="50%"
              innerRadius={50}
              outerRadius={65}
              startAngle={90 - (360 * data[1].value) / 100}
              endAngle={-270}
              dataKey="value"
              isAnimationActive={false}
            >
              <Cell fill={COLORS_ARABIC[1]} stroke="none" />
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className={styles.legendRow}>
          <span
            className={styles.legendDot}
            style={{ background: COLORS_ARABIC[0] }}
          />{" "}
          {data[1].name}
          <span
            className={styles.legendDot}
            style={{ background: COLORS_ENGLISH[0], marginLeft: 24 }}
          />{" "}
          {data[0].name}
        </div>
      </> : <DataLoader />
    }
  </div>
);

export default UsersPerLanguageChart;
